import React from "react"
import { navigate } from "gatsby"
import { isMobileOnly } from "react-device-detect"

import { makeStyles } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"

import { usePersons } from "../hooks/use-persons"
import { useBooks } from "../hooks/use-books"

const useStyles = makeStyles({
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18
    }
  }
})

export default function Search() {
  const classes = useStyles()
  const personsRaw = usePersons()
  const booksRaw = useBooks()

  const books = booksRaw.map(bookRaw => ({
    ...bookRaw,
    type: "books"
  }))
  const persons = personsRaw.map(personRaw => ({
    ...personRaw,
    type: "persons"
  }))

  const handleSearchClick = option => {
    if (option.type === "books") {
      navigate("/books/" + option.alias, {
        state: { alias: option.alias }
      })
    } else if (option.type === "persons") {
      navigate("/persons/" + option.alias, {
        state: { alias: option.alias }
      })
    }
  }

  return (
    <Autocomplete
      freeSolo
      id="search-books-or-persons"
      style={{ display: "contents" }}
      options={persons.concat(books)}
      groupBy={option => option.type}
      classes={{
        option: classes.option
      }}
      autoHighlight
      onChange={(event, option) => handleSearchClick(option)}
      getOptionLabel={option =>
        option.type === "persons" ? option.name : option.title
      }
      renderOption={option => (
        <React.Fragment>
          <img
            style={{ width: 48, height: 48, marginRight: 8 }}
            src={require("../images/" +
              option.type +
              "/" +
              option.alias +
              ".jpg")}
            alt={option.alias}
          />
          {option.type === "persons" ? option.name : option.title}
        </React.Fragment>
      )}
      renderInput={params => (
        <TextField
          {...params}
          label={isMobileOnly ? "Search..." : "Search for books or people..."}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            // Do not remove this
            autoComplete: "new-password"
          }}
        />
      )}
    />
  )
}
